import React from 'react'
import _ from 'lodash/fp'
import {getFileNameAndExtension, getUUID} from '../../utils/AttachmentsUtils'
import {MiraxParserConfig, parseMiraxRecords} from './MiraxParser'
import {FILE_TYPES} from '../../utils/FileType'
import {SVS_DOCTYPE} from '../NonDicomBox'
import {HamamatsuVMS, HamamatsuVMU, Mirax} from '../../enums/RecordFormat'
import {Pathology} from '../../enums/RecordClass'
import {HamamatsuVMSParserConfig} from './HamamatsuVMSPathologyParser'
import {HamamatsuVMUParserConfig} from './HamamatsuVMUPathologyParser'

const addFilename = ({file,path}) => {
  const [filename,extension] = getFileNameAndExtension(file)
  return ({
    file,
    path,
    filename,
    extension
  })
}

export const createRecord = (group,format,mode) => {
  const recordKey = getUUID()
  const rootPath = _.minBy('path',group).path
  return {
    description: group[0].filename,
    key: recordKey,
    multiFile:true,
    instances: group.map(({file,path,...rest}) => ({sourceFile:file,multiFile:true,recordKey,path:path.replace(rootPath,''),mode: mode ? mode : 'normal',...rest})),
    format,
    recordClass:Pathology,
    mode: mode ? mode : 'normal'
  }
}

export const parseMultiFilePathology = (files,mode) => {
  const formattedFiles = files.map(addFilename)
  const [miraxGroups,miraxDiscardedFiles] = multiPathologyParser(MiraxParserConfig)(formattedFiles,mode)
  const [vmsGroups,vmsDiscardedFiles] = multiPathologyParser(HamamatsuVMSParserConfig)(formattedFiles,mode)
  const [vmuGroups,vmuDiscardedFiles] = multiPathologyParser(HamamatsuVMUParserConfig)(formattedFiles,mode)
  return [
    [
      ...miraxGroups.map((group) => createRecord(group,Mirax,mode)),
      ...vmsGroups.map((group) => createRecord(group,HamamatsuVMS,mode)),
      ...vmuGroups.map((group) => createRecord(group,HamamatsuVMU,mode))
    ],
    [...vmuDiscardedFiles,...vmsDiscardedFiles,...miraxDiscardedFiles]
  ]
}


export const multiPathologyParser = (config) => (allFiles) => {

  const compatibleFiles = allFiles.filter(({extension}) =>
    extension && config.WHITE_LIST.indexOf(extension.toLowerCase()) >= 0
  )

  const [validGroups, discardGroups] = _.flow(
    _.filter(config.PRIMARY_EVIDENCE),
    _.map((primaryFile) => [primaryFile].concat(compatibleFiles.filter((other) => other.file !== primaryFile.file && config.FILTER_GROUP(primaryFile, other)))),
    _.partition(config.VALIDATE)
  )(compatibleFiles)
  return [validGroups,_.flatten(discardGroups)]
}